import Modal from "react-bootstrap/Modal";
import { AxisDate } from "../util/AxisDateTime";
import { TimesheetWeekDisplay } from "../components/TimesheetWeekDisplay";

const TimesheetWeekViewerModal = ({ visible, close, timesheetWeek }) => {
  return (
    <Modal
      show={visible}
      onHide={close}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title
          id="contained-modal-title-vcenter"
          className={"text-capitalize"}
        >
          Timesheet Week Ending {AxisDate(timesheetWeek?.weekEnding)}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <TimesheetWeekDisplay timesheetWeek={timesheetWeek} close={close} />
      </Modal.Body>
    </Modal>
  );
};

export default TimesheetWeekViewerModal;
